import React from 'react';
import PropTypes from 'prop-types';

import { Controls, ControlsBlock } from 'components/Controls';
import Search from 'components/filters/Search';
import SortFilters from 'components/filters/SortFilters';

import styles from './styles.module.scss';

const sortOptions = [
	{
		title: 'Самые популярные',
		name: '-views'
	},
	{
		title: 'Менее популярные',
		name: 'views'
	},
	{
		title: 'Фамилия по убывающей',
		name: '-surname'
	},
	{
		title: 'Фамилия по возрастающей',
		name: 'surname'
	}
];

const MobileEventControls = ({ filters = {}, onFilterChange }) => {
	const { sort, query } = filters;

	return (
		<>
			<div className={styles.MobileControls}>
				<Controls
					bottom={
						<SortFilters
							onFilterChange={onFilterChange}
							currentSort={sort}
							options={sortOptions}
						/>
					}
				>
					<ControlsBlock className={styles.MobileControls__Block}>
						<Search
							onEnter={onFilterChange}
							defaultTitle="Поиск по персонам"
							placeholder=""
							value={query}
						/>
					</ControlsBlock>
				</Controls>
			</div>
		</>
	);
};

MobileEventControls.propTypes = {
	onFilterChange: PropTypes.func,
	filters: PropTypes.shape({
		sort: PropTypes.string,
		query: PropTypes.string,
		rubric: PropTypes.shape({
			selected: PropTypes.string,
			options: PropTypes.arrayOf(
				PropTypes.shape({
					title: PropTypes.string.isRequired,
					name: PropTypes.string
				})
			)
		})
	})
};

export default MobileEventControls;
